import type { Offer } from '@fourthwall/services/dist/models/offer'

import type { VariantSelectOption } from './types'

export const getSelectOptionsFromVariants = (variants: Offer.Variant[]): VariantSelectOption[] =>
  variants.map((variant) => ({
    label: variant.attributesDescription,
    value: variant.id,
    quantity: variant.quantity,
  }))
